<template>
    <div>
        <vue-headful :title="'Carriers ('+carrierCount+') - AMOS365'" />

        <h4 class="page-header">
            Carriers ({{ carrierCount }})

            <router-link to="/carriers/create" class="btn btn-sm btn-info" v-if="canManageCarriers">
                <i class="fas fa-plus-square"></i> Create
            </router-link>
        </h4>

        <div class="card">
            <div class="card-body">
                <v-server-table ref="carriersTable" url="/carriers" :columns="columns" :options="options">

                    <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                    </div>

                    <div slot="afterFilter" class="ml-2">
                        <button type="button" class="btn btn-sm btn-default" v-on:click="exportTable()" :disabled="exportingTable">
                            <template v-if="!exportingTable"><i class="fa fa-file-excel"></i> Export</template>
                            <template v-else><i class="fa fa-spinner fa-spin"></i> Exporting</template>
                        </button>
                    </div>

                    <template slot="carrier_name" slot-scope="props">
                        <router-link :to="`/carriers/view/${props.row.id}`">{{ props.row.carrier_name }}</router-link>
                    </template>

                    <template slot="is_active" slot-scope="props">
                        <label class="badge badge-success" v-if="props.row.is_active == 1">Active</label>
                        <label class="badge badge-warning" v-else>Inactive</label>
                    </template>
                </v-server-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                carrierCount: null,
                exportingTable: false,
                columns: ['carrier_name', 'email', 'address', 'city', 'state_name', 'zip', 'is_active'],
                options: {
                    headings: {
                        carrier_name: 'Carrier',
                        email: 'Email',
                        address: 'Address',
                        city: 'City',
                        state_name: 'State',
                        is_active: 'Active',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'carriers.carrier_name',
                    },
                    texts:{
                        filterPlaceholder:"Search Carriers",
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        if(this.carrierCount === null)
                        {
                            //Set the count
                            this.carrierCount = response.data.count;
                        }
                        //this.$emit('carrierListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },
            }
        },

        watch: {

        },

        computed: {

            canManageCarriers(){
                //Check Permissions
                return this.$root.hasPermission(['carriers.manage']);
            },
        },

        methods: {
            exportTable(){
                //Loading indicator
                this.exportingTable = true;

                //Build the Filters
                //var filters = filterExtractor.extractFilters(this.filters);

                //Setup Columns
                var cols = JSON.parse(JSON.stringify(this.$refs.carriersTable.columns));

                //Build the payload
                var payload = {
                    //filters: filters,
                    query: (this.$refs.carriersTable.getRequestParams()).query,
                    orderBy: this.$refs.carriersTable.options.orderBy.column,
                    ascending: this.$refs.carriersTable.options.orderBy.ascending,
                    table: 'carriersTable',
                    columns: cols,
                    export: true,
                };

                //Send it
                this.$http.get('/carriers', payload)
                    .then(response => {
                        //Open the new window to Download the File
                        if(response.data.queued)
                        {
                            //Alert the User
                            this.$toastr.s(response.data.message);
                        }
                        else
                        {
                            //Open the download URL
                            window.open(response.data.url);
                        }
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.e(JSON.stringify(err), 'Failed to Export');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },
        },

        mounted() {
            //Focus on the SEarch Input
            this.$refs.carriersTable.$refs.genericFilter.focus();
        }
    }
</script>
